import Signup    from './Signup'
import Signin    from './Signin'
import Reset     from './Reset'
import Activate  from './Activate'
import Socialite from './Socialite'

export default [
    {path: '/signup/:campaign?',     components: {default: Signup   } },
    {path: '/signin',                components: {default: Signin   } },
    {path: '/password/reset/:token', components: {default: Reset    }, props: true },
    {path: '/activate/:token',       components: {default: Activate }, props: true },
    {path: '/auth/:provider',        components: {default: Socialite}, props: true},
]
